import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {
    UpgradeHelper, JourneyImportAndExportHelper,AdminToolHelper
} from '../../../helpers';

import { Checkbox, Button, Pivot, PivotItem, PivotLinkSize, IDropdownOption, ButtonType } from 'office-ui-fabric-react';
import store from '../../../store/store';
import { AdminToolList,ZipImport } from '../../admintool/panels';
import { ProcessUpgradePage } from '../../admintool/screens/processupgradepage';

interface IProps {
    adminToolState: any;
    searchState: any;
}
declare var jQuery;
export class ImportScreen extends React.Component<IProps, any> {
    componentDidMount() {
    }
    onSelectUpgradeToolMode(mode: string) {
        AdminToolHelper.SetPageMode(mode);
    }

    getButtonCss(mode): string {
        return this.props.adminToolState.pageMode == mode ? "active" : "";
    }
    render() {
        if (this.props.adminToolState.isUpgradingScreen) {
            return (<div>
                <ProcessUpgradePage showStatus={false} adminToolState={this.props.adminToolState} />
            </div>);
        }
        else {
            let textBoxValue: string = "";
            return (<div>
                <h2>Import tool</h2>
                <ZipImport panelName="importscreen_fileupload" adminToolState={this.props.adminToolState} isDisplayed={true} />
                <AdminToolList panelTitle={"Journeys to import"} panelName={"importscreen_AdminToolList"} adminToolState={this.props.adminToolState} 
                    enableRemoveButtons={false} showStatus={false} />
                <div className="upgradesettings">
                    <div className="upgradesettinglist">
                        <label>Show Verbose Output:</label>
                        <Checkbox name="advancedLogging" default={false}
                            onChange={(e, isChecked: boolean) => {
                                AdminToolHelper.SetAdminToolSetting(isChecked);
                            }}
                        />
                    </div>
                    <Button
                        icon="Accept"
                        buttonType={ButtonType.primary}
                        onClick={() => {
                            var form = jQuery('#zipfileuploadform')[0];
                            var formData = new FormData(form);
                            JourneyImportAndExportHelper.StartUpImportProcess(this.props.adminToolState.processList, formData)
                        }
                        }>
                        Start Importing Journeys
                        </Button>
                </div>
            </div>
            );
        }
    }
}




// WEBPACK FOOTER //
// ./source/ts/components/admintool/screens/importscreen.tsx